import { render, staticRenderFns } from "./AlertConfig.vue?vue&type=template&id=7c7bb8ec&scoped=true"
import script from "./AlertConfig.vue?vue&type=script&lang=js"
export * from "./AlertConfig.vue?vue&type=script&lang=js"
import style0 from "./AlertConfig.vue?vue&type=style&index=0&id=7c7bb8ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7bb8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7bb8ec')) {
      api.createRecord('7c7bb8ec', component.options)
    } else {
      api.reload('7c7bb8ec', component.options)
    }
    module.hot.accept("./AlertConfig.vue?vue&type=template&id=7c7bb8ec&scoped=true", function () {
      api.rerender('7c7bb8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/AlertConfig.vue"
export default component.exports